 
    <app-generic-calendar
      (onInputChangeValid)="onFilter($event)"
      (onSelect)="onFilter($event)"
      [value]="field.value"
      [timeOnly]="true"
      [showOnFocus]="true"
    ></app-generic-calendar>
  